import React, { Component } from 'react'
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import './binaryselect.scss';

import asyncRoute from '../../helpers/hoc/asyncRoute';
import Error from '../FormElements/error';

const Tooltip = asyncRoute(() => import('../../components/FormElements/ToolTip'));

export default class index extends Component {
  render() {
    const { onChange, disabled, onBlur, setting, submited, touched, error, value, toggle, options, dvLength, ionLength } = this.props;
    const { labelLayout = 'col-sm-4', valueKey = 'id', textKey = 'value', addModel = false } = setting
    
    return (
      <div className="form-group row">
        {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required)?<span className='text-danger'>*</span>:<><br/><span className="small" style={{color:"#1925238a"}}>Optional</span></>}</label>}
        <div className={setting.displayLayout}>
          <div className={isEmpty(error) ? `radio-group ${disabled ? 'binary-input-disabled' : ''}` : "radio-group binary-error"}>
            {_.map(options, (item, index) => (
              <>
                <input
                key={index}
                  onChange={(event) => { onChange(event); onBlur(event); }}
                  onBlur={onBlur}
                  value={item[valueKey]}
                  id={setting.key + index}
                  name={setting.key}
                  type="radio"
                  className='binary-input'
                  disabled={disabled}
                  checked={value === '' && item[valueKey] == 0 ? true : item[valueKey] == value}
                  />
                <label className='binary-label' htmlFor={setting.key + index}>{item[textKey]}</label>
              </>
            ))}
          </div>
          {(submited || touched) && (<Error setting={setting} error={error} />)}
        </div>
        {setting.tooltip && <Tooltip text={setting.tooltip} />}
        {addModel && <i onClick={toggle} className="mdi mdi-plus-box btnSelectCursor"></i>}
      </div>
    )
  }
}

// -----* select propTypes set  *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
  }),
}